import AthubAxios from '../../util/athub-axios/core.js'
import {ATHUB_CLOUD_SERVER, WORKFLOW_SERVER} from '../server'

const WorkflowApi = {

    history(bussinessInfo) {
        let url = `${ATHUB_CLOUD_SERVER}/workflow/process/${bussinessInfo.bussiness}/${bussinessInfo.bussinessId}.sp`;
        let promise = new Promise((resolve, reject) => {
            AthubAxios.postByForm(url, null, null).then(responseBody => {
                if (responseBody.status == 200 && responseBody.data.result == 'OK') {
                    resolve(responseBody.data.list);
                } else {
                    reject(responseBody.data.message);
                }
            }, (error) => {
                reject(error);
            })
        });
        return promise;
    },

    request(bussinessInfo) {
        let url = `${ATHUB_CLOUD_SERVER}/workflow/request/${bussinessInfo.bussiness}/${bussinessInfo.bussinessId}.sp`;
        let promise = new Promise((resolve, reject) => {
            AthubAxios.postByForm(url, bussinessInfo, null).then(responseBody => {
                if (responseBody.status == 200 && responseBody.data.code == 'OK') {
                    resolve(responseBody.data);
                } else {
                    reject(responseBody.data.message);
                }
            }, (error) => {
                reject(error);
            })
        });
        return promise;
    },

    audit(bussinessInfo) {
        let url = `${ATHUB_CLOUD_SERVER}/workflow/audit/${bussinessInfo.bussiness}/${bussinessInfo.bussinessId}.sp`;
        let promise = new Promise((resolve, reject) => {
            AthubAxios.postByMultipartForm(url, bussinessInfo, null).then(responseBody => {
                if (responseBody.status == 200 && responseBody.data.code == 'OK') {
                    resolve(responseBody.data);
                } else {
                    reject(responseBody.data.message);
                }
            }, (error) => {
                reject(error);
            })
        })
        return promise;
    },

    accept(bussinessInfo) {
        let url = `${ATHUB_CLOUD_SERVER}/workflow/accept/${bussinessInfo.bussiness}/${bussinessInfo.bussinessId}.sp`;
        return new Promise((resolve, reject) => {
            AthubAxios.postByMultipartForm(url, bussinessInfo, null).then(responseBody => {
                if (responseBody.status === 200 && responseBody.data.code === 'OK') {
                    resolve(responseBody.data);
                } else {
                    reject(responseBody.data.message);
                }
            }, (error) => {
                reject(error);
            })
        });
    },


}

const WorkflowApiNew = {

    history(bussinessInfo) {
        let url = `${WORKFLOW_SERVER}/workflow/process/${bussinessInfo.bussiness}/${bussinessInfo.bussinessId}.sp`;
        return new Promise((resolve, reject) => {
            AthubAxios.postByForm(url, null, null).then(responseBody => {
                if (responseBody.status === 200 && responseBody.data.result === 'OK') {
                    resolve(responseBody.data.list);
                } else {
                    reject(responseBody.data.message);
                }
            }, (error) => {
                reject(error);
            })
        });
    },

    request(bussinessInfo) {
        let url = `${WORKFLOW_SERVER}/workflow/request/${bussinessInfo.bussiness}/${bussinessInfo.bussinessId}.sp`;
        return new Promise((resolve, reject) => {
            AthubAxios.postByMultipartForm(url, bussinessInfo, null).then(responseBody => {
                if (responseBody.status === 200 && responseBody.data.code === 'OK') {
                    resolve(responseBody.data);
                } else {
                    reject(responseBody.data.message);
                }
            }, (error) => {
                reject(error);
            })
        });
    },

    audit(bussinessInfo) {
        let url = `${WORKFLOW_SERVER}/workflow/audit/${bussinessInfo.bussiness}/${bussinessInfo.bussinessId}.sp`;
        return new Promise((resolve, reject) => {
            AthubAxios.postByMultipartForm(url, bussinessInfo, null).then(responseBody => {
                if (responseBody.status === 200 && responseBody.data.code === 'OK') {
                    resolve(responseBody.data);
                } else {
                    reject(responseBody.data.message);
                }
            }, (error) => {
                reject(error);
            })
        });
    },

    fetchCurrentTaskIds(business) {
        business = business == null ? 'INCIDENT' : business;
        var formData = new FormData();
        formData.append('appId', "WEB");
        formData.append('token', localStorage.getItem("token"));
        let url = `${WORKFLOW_SERVER}/workflow/fetchCurrentTaskIds/${business}.sp`;
        return new Promise((resolve, reject) => {
            AthubAxios.postByForm(url, formData, null).then(responseBody => {
                if (responseBody.status === 200 && responseBody.data.code === 'OK') {
                    resolve(responseBody.data);
                } else {
                    reject(responseBody.data.message);
                }
            }, (error) => {
                reject(error);
            })
        });
    }

};

export default WorkflowApi;
export {WorkflowApiNew};
